import React from 'react';
import { skills } from '../data/mock';

const Skills = () => {
  const skillCategories = [
    { title: 'Cloud Platforms', items: skills.cloud, color: 'blue' },
    { title: 'Containers & Orchestration', items: skills.containers, color: 'red' },
    { title: 'CI/CD Tools', items: skills.cicd, color: 'yellow' },
    { title: 'Infrastructure as Code', items: skills.iac, color: 'green' },
    { title: 'Monitoring & Observability', items: skills.monitoring, color: 'purple' },
    { title: 'Security & Compliance', items: skills.security, color: 'indigo' },
    { title: 'Programming Languages', items: skills.programming, color: 'pink' },
    { title: 'Databases', items: skills.databases, color: 'orange' },
    { title: 'Data Engineering', items: skills.data, color: 'cyan' },
    { title: 'Other Technologies', items: skills.other, color: 'teal' }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      blue: 'border-blue-300 bg-blue-50 text-blue-600 hover:bg-blue-100',
      red: 'border-red-300 bg-red-50 text-red-600 hover:bg-red-100',
      yellow: 'border-yellow-300 bg-yellow-50 text-yellow-600 hover:bg-yellow-100',
      green: 'border-green-300 bg-green-50 text-green-600 hover:bg-green-100',
      purple: 'border-purple-300 bg-purple-50 text-purple-600 hover:bg-purple-100',
      indigo: 'border-indigo-300 bg-indigo-50 text-indigo-600 hover:bg-indigo-100',
      pink: 'border-pink-300 bg-pink-50 text-pink-600 hover:bg-pink-100',
      orange: 'border-orange-300 bg-orange-50 text-orange-600 hover:bg-orange-100',
      teal: 'border-teal-300 bg-teal-50 text-teal-600 hover:bg-teal-100',
      cyan: 'border-cyan-300 bg-cyan-50 text-cyan-600 hover:bg-cyan-100'
    };
    return colorMap[color] || colorMap.blue;
  };

  const getTitleColor = (color) => {
    const colorMap = {
      blue: 'text-blue-600',
      red: 'text-red-600',
      yellow: 'text-yellow-600',
      green: 'text-green-600',
      purple: 'text-purple-600',
      indigo: 'text-indigo-600',
      pink: 'text-pink-600',
      orange: 'text-orange-600',
      teal: 'text-teal-600'
    };
    return colorMap[color];
  };

  return (
    <section id="skills" className="py-24 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-yellow-500">Technical</span>{' '}
            <span className="text-green-500">Skills</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Comprehensive DevOps and Cloud Engineering expertise
          </p>
          <div className="w-20 h-1 bg-gradient-to-r from-yellow-500 to-green-500 mt-4 mx-auto rounded-full"></div>
        </div>

        {/* Skills Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {skillCategories.map((category, idx) => (
            <div
              key={idx}
              className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-blue-300 transition-all duration-300 hover:shadow-xl"
            >
              <h3 className={`text-xl font-bold ${getTitleColor(category.color)} mb-4`}>{category.title}</h3>
              <div className="flex flex-wrap gap-2">
                {category.items.map((skill, skillIdx) => (
                  <span
                    key={skillIdx}
                    className={`px-3 py-2 text-sm rounded-lg border-2 font-semibold transition-all duration-200 hover:scale-105 ${
                      getColorClasses(category.color)
                    }`}
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;